import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvites, createInvite, resendInvite, revokeInvite, bulkInvite } from '../../actions/inviteActions';

const ROLES = ['customer', 'sales', 'manager', 'admin'];

export default function AdminInvites() {
  const dispatch = useDispatch();
  const { items, total, loading } = useSelector(s => s.invites);
  const [filterStatus, setFilterStatus] = useState('');
  const [form, setForm] = useState({ email: '', name: '', roleSlug: 'sales', message: '' });
  const [bulkText, setBulkText] = useState('');
  const [status, setStatus] = useState({ kind: '', text: '' });

  useEffect(() => { dispatch(fetchInvites({ status: filterStatus })); }, [dispatch, filterStatus]);

  const create = async (e) => {
    e.preventDefault();
    const res = await dispatch(createInvite(form));
    if (res.ok) {
      setForm({ email: '', name: '', roleSlug: 'sales', message: '' });
      setStatus({ kind: 'success', text: 'Invite sent.' });
    } else setStatus({ kind: 'error', text: res.error });
  };
  const bulk = async () => {
    const rows = bulkText.split('\n').map(line => {
      const [email, name, roleSlug] = line.split(',').map(s => s && s.trim());
      return { email, name, roleSlug };
    }).filter(r => r.email);
    if (rows.length === 0) { setStatus({ kind: 'error', text: 'Paste at least one email,name,role row.' }); return; }
    const res = await dispatch(bulkInvite(rows));
    if (res.ok) { setBulkText(''); setStatus({ kind: 'success', text: `Created ${res.created.length}, skipped ${res.skipped.length}.` }); }
    else setStatus({ kind: 'error', text: res.error });
  };

  return (
    <section className="section">
      <div className="section-head">
        <h1>Invites <span className="muted" style={{fontWeight:400,fontSize:'1rem'}}>({total})</span></h1>
      </div>

      <div className="card">
        <h2>Send an invite</h2>
        <form className="auth-form" onSubmit={create} style={{maxWidth:'620px'}}>
          <label>Email<input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></label>
          <label>Name (optional)<input value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></label>
          <label>Role
            <select value={form.roleSlug} onChange={e => setForm({...form, roleSlug: e.target.value})}>
              {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </label>
          <label>Personal message (optional)<textarea rows="3" value={form.message} onChange={e => setForm({...form, message: e.target.value})} /></label>
          <button className="btn-primary" type="submit">Send invite</button>
        </form>
      </div>

      <div className="card">
        <h2>Bulk invite (CSV-style)</h2>
        <p className="muted">One row per line: <code>email,name,role</code> &mdash; up to 200 rows.</p>
        <textarea rows="6" style={{width:'100%',padding:'.6rem',fontFamily:'ui-monospace,Menlo,monospace',fontSize:'.85rem',border:'1px solid #e6ebf0',borderRadius:'6px'}} value={bulkText} onChange={e => setBulkText(e.target.value)} placeholder={'sarah@example.com,Sarah Smith,sales\njim@example.com,Jim Doe,manager'} />
        <button className="btn-primary" type="button" onClick={bulk} style={{marginTop:'.8rem'}}>Send all</button>
      </div>

      <div className="card">
        <div className="section-head"><h2>Sent invites</h2>
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
            <option value="">All statuses</option>
            <option value="pending">Pending</option>
            <option value="accepted">Accepted</option>
            <option value="expired">Expired</option>
            <option value="revoked">Revoked</option>
            <option value="declined">Declined</option>
          </select>
        </div>
        <table className="data-table">
          <thead><tr><th>Email</th><th>Role</th><th>Status</th><th>Sent</th><th>Invited by</th><th style={{textAlign:'right'}}>Actions</th></tr></thead>
          <tbody>
            {loading && <tr><td colSpan="6" className="muted">Loading…</td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan="6" className="muted">No invites.</td></tr>}
            {items.map(i => (
              <tr key={i._id}>
                <td>{i.email}{i.name ? <div className="muted" style={{fontSize:'.8rem'}}>{i.name}</div> : null}</td>
                <td>{i.roleSlug}</td>
                <td>
                  <span style={{
                    color: i.status==='pending' ? '#3282b8' : i.status==='accepted' ? '#1a7a32' : '#6c7d92',
                    fontWeight: 700
                  }}>{i.status}</span>
                </td>
                <td>{new Date(i.createdAt).toLocaleDateString()}</td>
                <td>{i.invitedBy?.email || '—'}</td>
                <td style={{textAlign:'right'}}>
                  {i.status === 'pending' && <>
                    <button className="btn-ghost" style={{marginRight:'.4rem',padding:'.3rem .7rem'}} onClick={() => dispatch(resendInvite(i._id))}>Resend</button>
                    <button onClick={() => dispatch(revokeInvite(i._id))} style={{padding:'.3rem .7rem',border:'1.5px solid #f0c4c4',background:'white',color:'#b53b3b',borderRadius:'6px',cursor:'pointer',fontWeight:600,fontSize:'.85rem'}}>Revoke</button>
                  </>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {status.text && <p className={`status ${status.kind}`}>{status.text}</p>}
    </section>
  );
}
